// extracted by mini-css-extract-plugin
module.exports = {"ServicesDiv":"MasterCover_ServicesDiv__1CbNm","nameH1":"MasterCover_nameH1__1XjFH","nameH3":"MasterCover_nameH3__4MTEy","bodyDiv":"MasterCover_bodyDiv__1YDyM"};